import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import axios from "axios";

const PrivateRoute = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    axios
      .get("/backend/api/check-session.php", {
        withCredentials: true,
      })
      .then((res) => {
        setIsLoggedIn(res.data.loggedIn);
        setAuthChecked(true);
      })
      .catch((err) => {
        console.error("Session check failed:", err);
        setAuthChecked(true);
        setIsLoggedIn(false);
      });
  }, []);

  if (!authChecked) {
    return null; // Or a loading spinner
  }

  return isLoggedIn ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
